import { node } from "~/util/dom";

interface IDialogButtonOptions extends HTMLButtonElement {
	primary?: boolean;
}

export function createDialogButton({
	primary = false,
	className = "",
	...rest
}: Partial<IDialogButtonOptions>): HTMLButtonElement {
	const button = node("button", {
		type: "button",
		className: `ui-oldDialogButton ${primary ? "ui-oldDialogButton--primary" : ""} ${className}`,
		...rest,
	});

	return button;
};
